import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { USE_OPS_MOCKS } from 'pages/Operations/Shared/opsControl'
import { OtherText } from 'styling/Typography'
import { formatNumbersForDisplay } from 'utils/helpers'
import { IFuelBowserDayDispenseRow } from 'types/fuelCustody.interface'
import {
    FUEL_BOWSER_DAY_DETAIL,
    FUEL_BOWSER_DAY_DETAIL_NOTE,
} from 'pages/FuelManagement/fuelTanksDemoData'
import { BreakdownCellText, BreakdownTitle, BreakdownWrap } from './BowserDayBreakdown.styled'

const TOTAL_ROW_ID = 0

const columns: IHonestTableColumn<IFuelBowserDayDispenseRow>[] = [
    {
        id: 'machine',
        header: 'Machine',
        minWidth: '9rem',
        cell: (item) => <BreakdownCellText $em={item.id === TOTAL_ROW_ID}>{item.machine}</BreakdownCellText>,
    },
    {
        id: 'time',
        header: 'Time',
        cell: (item) => (item.id === TOTAL_ROW_ID
            ? <BreakdownCellText $em />
            : <BreakdownCellText>{item.time}</BreakdownCellText>),
    },
    {
        id: 'litres',
        header: 'Litres',
        align: 'right',
        cell: (item) => (
            <BreakdownCellText $em={item.id === TOTAL_ROW_ID}>
                {`${formatNumbersForDisplay(item.litres)} L`}
            </BreakdownCellText>
        ),
    },
]

export const BowserDayBreakdown = () => {
    const rows: IFuelBowserDayDispenseRow[] = USE_OPS_MOCKS ? FUEL_BOWSER_DAY_DETAIL : []
    if (!rows.length) return null
    const totalL = rows.reduce((sum, row) => sum + row.litres, 0)
    const tableRows: IFuelBowserDayDispenseRow[] = [
        ...rows,
        { id: TOTAL_ROW_ID, machine: 'Total', time: '', litres: totalL },
    ]
    return (
        <BreakdownWrap>
            <BreakdownTitle>Dispensed to machines — yesterday</BreakdownTitle>
            <HonestTable columns={columns} data={tableRows} keyField='id' />
            <OtherText grey>{FUEL_BOWSER_DAY_DETAIL_NOTE}</OtherText>
        </BreakdownWrap>
    )
}
